import { useState, useEffect } from "react";
import { getOngoingPromotions, updatePromotion } from "../services/AllServices";
import { showMessage } from "../utils/helpers";

const usePromotionsViewController = () => {
  const [loading, setLoading] = useState(false);
  const [editedPromotions, setEditedPromotions] = useState([]);
  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    getPromotions();
  }, []);

  const getPromotions = async () => {
    try {
      setLoading(true);
      let response = await getOngoingPromotions();
      setPromotions(response.data);
      setEditedPromotions(response.data);
      setLoading(false);
    } catch (error) {
      showMessage("error", error?.detail || "Something went wrong");
      setLoading(false);
    }
  };

  const updatePromotions = async () => {
    console.log(editedPromotions);
    try {
      setLoading(true);
      let response = await updatePromotion({
        promotions: editedPromotions,
      });
      setLoading(false);
      if (response) {
        showMessage("success", "Promotion updated successfully");
      } else {
        showMessage("error", response?.detail || "Something went wrong");
      }
    } catch (error) {
      showMessage("error", error?.detail || "Something went wrong");
      setLoading(false);
    }
  };

  return {
    loading,
    promotions,
    editedPromotions,
    setEditedPromotions,
    updatePromotions,
  };
};

export default usePromotionsViewController;
